import { LOGOTYPE_BLOCK_RECEIVE, LOGOTYPE_BLOCK_ERROR } from './LogotypeBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const LogotypeReducer = (state = defaultState, action) => {
    switch (action.type) {
        case LOGOTYPE_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case LOGOTYPE_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}